import React from 'react';
import TestimonialCard from './TestimonialCard';
import css from './TestimonialSection.module.css';
import prop1 from '../../assets/testimonial1.png';
import prop2 from '../../assets/testimonial2.png';
import prop3 from '../../assets/testimonial3.png';
import prop4 from '../../assets/testimonial4.png';

const TestimonialSection = ({ title, description, buttonLabel }) => {
  return (
    <div className={css.cardsSection}>
      <div className={css.leftColumn}>
        <h2 className={css.title}>{title}</h2>
        <p className={css.subheading}>{description}</p>
        <a href="/l/new" className={css.getStarted}>
          {buttonLabel}
        </a>
      </div>
      
      <div className={css.rightColumn}>
        <div className={css.cardRow}>
          <TestimonialCard
            image={prop1}
            name="Hamish"
            feedback="Buying direct saved me 17K in potential fees, and meant I could buy my first property earlier!"
          />
          <TestimonialCard
            image={prop2}
            name="Veena"
            feedback="It's truly the new way to buy & sell homes."
          />
        </div>
        <div className={css.cardRow2}>
          <TestimonialCard
            image={prop3}
            name="Emma"
            feedback="Such a great concept, a platform Kiwis have wanted for years!"
          />
          <TestimonialCard
            image={prop4}
            name="Ryan"
            feedback="Buying direct saved me 17K in potential fees, and meant I could buy my first property earlier!"
          />
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;
